import { Direction } from "../interfaces/table";

/**
 * Sorts an array of objects by multiple fields and directions
 * @param data The data to sort
 * @param fields The fields to sort by, in order. Nested fields can be accessed by using a dot, e.g. "address.street".
 * @param directions The directions to sort by, in order. If not provided, all fields will be sorted in ascending order
 * @returns
 */
export function orderBy<T>(
  data: T[] | undefined | null,
  fields: string[] | string,
  directions?: Direction[] | Direction,
): T[] {
  if (!data) return [];
  const fieldsArray = Array.isArray(fields) ? fields : [fields];
  const directionsArray = Array.isArray(directions) ? directions : [directions];
  // @ts-ignore
  return data.toSorted((a, b) => {
    for (let i = 0; i < fieldsArray.length; i++) {
      const field = fieldsArray[i];
      const direction =
        directionsArray && directionsArray[i] ? directionsArray[i] : "asc";
      const fieldArray = field.split(".");
      const aValue = fieldArray.reduce((acc, val) => {
        if (!acc) return acc;
        return acc[val];
      }, a);
      const bValue = fieldArray.reduce((acc, val) => {
        if (!acc) return acc;
        return acc[val];
      }, b);
      if (typeof aValue === "string" && typeof bValue === "string") {
        if (aValue.localeCompare(bValue, "da-DK") === -1) {
          return direction === "asc" ? -1 : 1;
        } else if (aValue.localeCompare(bValue, "da-DK") === 1) {
          return direction === "asc" ? 1 : -1;
        }
      }
      if (aValue === undefined || aValue === null) {
        return direction === "asc" ? -1 : 1;
      }
      if (aValue < bValue) {
        return direction === "asc" ? -1 : 1;
      } else if (aValue > bValue) {
        return direction === "asc" ? 1 : -1;
      }
    }
    return 0;
  });
}
